import { useState } from 'react';
import type { ReactNode } from 'react';
import { ChevronDown, Plus } from 'lucide-react';

/**
 * FormSection — bloco de formulário com progressive disclosure.
 *
 * O formulário começa curto e cresce sob demanda: pedimos o essencial, o resto
 * fica atrás de "+ Mais informações". Cadastro de fornecedor é o caso típico —
 * o CNPJ primeiro, o resto depois.
 */
export function FormSection({
  title,
  description,
  children,
}: {
  title?: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <section className="formsection">
      {title && <div className="formsection__title">{title}</div>}
      {description && <div className="formsection__description">{description}</div>}
      {children}
    </section>
  );
}

export function CollapsibleSection({
  label,
  children,
  defaultOpen = false,
}: {
  label: string;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="formsection">
      <button type="button" className="formsection__toggle" onClick={() => setOpen((v) => !v)}>
        {open ? <ChevronDown size={14} aria-hidden /> : <Plus size={14} aria-hidden />}
        {label}
      </button>
      {open && <div style={{ marginTop: 14 }}>{children}</div>}
    </div>
  );
}

/** Campo de formulário com rótulo, erro e dica — o erro sempre em pt-BR. */
export function Field({
  label,
  error,
  hint,
  children,
  htmlFor,
  required,
}: {
  label: string;
  error?: string;
  hint?: string;
  children: ReactNode;
  htmlFor?: string;
  /** Asterisco no rótulo. Só visual: quem barra é a validação. */
  required?: boolean;
}) {
  return (
    <div className="field">
      <label className="field__label" htmlFor={htmlFor}>
        {label}
        {required && (
          <span className="lanc__obrigatorio" aria-hidden>
            {' '}
            *
          </span>
        )}
      </label>
      {children}
      {error ? (
        <div className="field__error" role="alert">
          {error}
        </div>
      ) : (
        hint && <div className="field__hint">{hint}</div>
      )}
    </div>
  );
}
